import HttpClient from "./httpClient";
import { baseURL } from "../config";

class APIClient extends HttpClient {
    constructor() {
        super(baseURL + '/v1');
    }
}

export const apiClient = new APIClient();